/**
 * This file is to map delay condition , from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { recurringConditionEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import {
	getEdge,
	getEndCoachmarkNode,
	getNextTarget,
	getShadowsForStep,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import { buildContactJsonFromFilterForAutomation, buildConditionsFromJsonFilterString } from "assets/js/utils/contactUtils";

const parseBEFilterSetToFE = (
	automation,
	mainStep,
	subStep,
	targetId
) => {
	const events = [];
	const eventConfigs = recurringConditionEvents().filter(
		(event) => event.id == "filterSet"
	)[0];
	events.push({
		id: mainStep.name,
		position: {
			x: 0,
			y: 0,
		},
		data: {
			name: eventConfigs.name,
			desc: eventConfigs.desc,
			type: "condition",
			tileTitle: eventConfigs.tileTitle,
			id: mainStep.name,
			baseId: "filterSet",
			conditions: buildConditionsFromJsonFilterString(mainStep.args["input.data.filter"]),
			initialElement: false,
			shadows: getShadowsForStep(automation, mainStep.name),
		},
		type: "editorNode",
	});
	const links = [];
	if (targetId) {
		links.push(getEdge("custom", mainStep.name, targetId));
	} else {
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(getEdge("custom", mainStep.name, endCoachmark.id));
	}
	return {
		events: events,
		links: links,
	};
};

const parseFEFilterSetToBE = (FEEvent, connectedEdges, events) => {
	let shadows = [];
	let inTos = [];
	const filter = buildContactJsonFromFilterForAutomation(FEEvent.data.conditions.conditions, FEEvent.data.conditions.operator)

	if (FEEvent.data.shadows) shadows = [...FEEvent.data.shadows];
	inTos = events
		.filter((e) => e.data.baseId == "loop")
		.filter((e) => e.data.goTo == FEEvent.id);
	if (inTos.length > 0) inTos = inTos.map((e) => `${e.id}_loop`);
	return {
		main: [
			{
				steps: [
					{
						name: `${FEEvent.id}`,
						action: "SubAutomation.Call",
						args: {
							sub_automation: FEEvent.id,
						},
						next: "end",
						shadows: shadows,
						inTos: inTos,
					},
				],
			},
		],
		sub: [
			{
				name: FEEvent.id,
				params: [],
				type: "filterSet",
				steps: [
					{
						name: FEEvent.id,
						action: "Variable.Set",
						args: {
							"input.data.filter" : filter,
						},
						next: getNextTarget(connectedEdges, events),
					},
				],
			},
		],
		reusableSubAutomations: ["emit_next_step"],
	};
};

export { parseBEFilterSetToFE, parseFEFilterSetToBE };
